import React from "react";
import { ContractRenameWorkflow } from "./ContractRenameWorkflow";

type Props = {
  active: boolean;
};

export default function AdminContractRenamePanel({ active }: Props) {
  if (!active) {
    return null;
  }
  return <ContractRenameWorkflow embedded={false} />;
}
